const initial = {
  loading: false,
  data: {},
  error: null
};

// reducers
export default function bannerProducts(state = initial, action) {
  const { loading, error, data, jioAdsProducts = {} } = action.payload || {};
  
  switch (action.type) {
    case 'FETCH_PRODUCTS_DETAIL_PENDING':
      return {
        ...state,
        loading,
        data: {
          ...state.data
        },
        error
      };
    case 'FETCH_PRODUCTS_DETAIL_SUCCESS':
      return {
        ...state,
        loading,
        data: {
          ...state.data,
          ...data
        },
        error
      };
    case 'FETCH_PRODUCTS_DETAIL_FAILURE':
      return {
        ...state,
        loading,
        data: {
          ...state.data
        },
        error
      };
     case 'FETCH_JIOADS_PRODUCTS_DETAIL_PENDING':
      return {
        ...state,
        loading,
        data: {
          ...state.data
        },
        error
      };
    case 'FETCH_JIOADS_PRODUCTS_DETAIL_SUCCESS':
      return {
        ...state,
        loading,
        data: {
          ...state.data,
          ...jioAdsProducts
        },
        error
      };
    case 'FETCH_OSMOS_ADS_PRODUCTS_DETAIL_SUCCESS':
      return {
        ...state,
        loading,
        data: {
          ...state.data,
          ...jioAdsProducts
        },
        error
      };
    case 'FETCH_JIOADS_PRODUCTS_DETAIL_FAILURE':
      return {
        ...state,
        loading,
        data: {
          ...state.data
        },
        error
      };
    default:
      return state;
  }
}
